import { initializeApp } from "firebase/app";
import {
  GoogleAuthProvider,
  getAuth,
  signInWithPopup,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import {
  getFirestore,
  query,
  getDocs,
  collection,
  where,
  addDoc,
} from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyADtuA6qwU9HDpmT79A4Sq5HtIyOzX8-Uo",
  authDomain: "movielist-fb821.firebaseapp.com",
  projectId: "movielist-fb821",
  storageBucket: "movielist-fb821.appspot.com",
  messagingSenderId: "500010961823",
  appId: "1:500010961823:web:2ee343a8b2435a76748baa",
  measurementId: "G-P3N0LRCJG7",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const googleProvider = new GoogleAuthProvider();
const signInWithGoogle = async () => {
  try {
    const res = await signInWithPopup(auth, googleProvider);
    const user = res.user;
    const q = query(collection(db, "users"), where("uid", "==", user.uid));
    const docs = await getDocs(q);
    if (docs.docs.length === 0) {
      await addDoc(collection(db, "users"), {
        uid: user.uid,
        name: user.displayName,
        authProvider: "google",
        email: user.email,
      });
    }

    localStorage.setItem(
      "token",
      JSON.stringify(user.uid)
    );
    localStorage.setItem(
      "name",
      JSON.stringify(user.displayName)
    );
    localStorage.setItem(
      "image",
      JSON.stringify(user.photoURL)
    );
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};

const logInWithEmailAndPassword = async (email, password) => {
  try {
    const res = await signInWithEmailAndPassword(auth, email, password);
    const user = res.user;
    localStorage.setItem(
      "token",
      JSON.stringify(user.uid)
    );
    localStorage.setItem(
      "name",
      JSON.stringify("Users")
    );
    localStorage.setItem(
      "image",
      JSON.stringify(null)
    );

  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};

const registerWithEmailAndPassword = async (name, email, password) => {
  try {
    const res = await createUserWithEmailAndPassword(auth, email, password);
    const user = res.user;
    await addDoc(collection(db, "users"), {
      uid: user.uid,
      name,
      authProvider: "local",
      email,
    });
  } catch (err) {
    console.error(err);
    alert(err.message);
  }
};

const logout = () => {
  signOut(auth);
};


export {
  auth,
  db,
  signInWithGoogle,
  logInWithEmailAndPassword,
  signInWithEmailAndPassword,
  registerWithEmailAndPassword,
  logout,
};